import { API_PREFIX } from "./api.constants";

export const AUTH_ENDPOINTS = {
  LOGIN: `${API_PREFIX}/auth/`,
  REFRESH_TOKEN: `${API_PREFIX}/auth/token/refresh`,
  LOGOUT: `${API_PREFIX}/auth/logout`,
  REGISTER: `${API_PREFIX}/auth/register`,
  LDAP_LOGIN: `${API_PREFIX}/auth/ldap-login`,
};

